const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Menus {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });
}

export default new Menus('/auth/v1/menus');



// WEBPACK FOOTER //
// ./src/libraries/api/menu.tsx